import { buildCircleStroke, buildRectStroke } from "routes/qrcodes/qr_design/utils/StrokeBuilder";

export const qrDesignStyleExtension = (svg, options, qrDesignFormDataDetails) => {
	const DOUBLE = 2;
	const { shape, width, height, stroke: { width: strokeWidth } } = qrDesignFormDataDetails;
	if (strokeWidth >= 0) {
		const svgCopy = svg.cloneNode(true);
		const borderBuilderMap = {
			["square"]: () => {
				const { width, height, stroke } = qrDesignFormDataDetails;
				return buildRectStroke(width, height, stroke);
			},
			["circle"]: () => {
				svgCopy.setAttribute("style", "clip-path: inset(0 0 0 0 round 50%);");
				const { width, height, stroke } = qrDesignFormDataDetails;
				return buildCircleStroke(width, height, stroke);
			},
		};
		svg.innerHTML = "";
		svgCopy.setAttribute("viewBox", `0 0 ${width} ${height} `);
		svgCopy.setAttribute("width", `${width - DOUBLE * strokeWidth}`);
		svgCopy.setAttribute("height", `${height - DOUBLE * strokeWidth}`);
		svgCopy.setAttribute("x", strokeWidth.toString());
		svgCopy.setAttribute("y", strokeWidth.toString());
		svg.appendChild(svgCopy);
		svg.appendChild(borderBuilderMap[shape](options));
	}
};
